import React, {Component} from 'react';
import * as firebase from 'firebase';
import FontAwesome from 'react-fontawesome';

/** @class BackgroundNoise
  * A component for adding background noise to a stage.
  */
export default class BackgroundNoise extends Component {
  /** @constructor
    * Creates a new BackgroundNoise instance.
    */
  constructor(props) {
    super(props);
    this.dataRef = firebase.database().ref(this.props.dataURL);
    this.state = {audio: null, isPlaying: false};
    this.audio = new Audio();
    this.playAudio = this.playAudio.bind(this);
    this.pauseAudio = this.pauseAudio.bind(this);
    this.removeAudio = this.removeAudio.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to firebase and loads the sound
    */
  componentWillMount() {
    this.dataRef.on('value', snapshot => {
      var audio = snapshot.val();
      if(audio) {
        this.audio.src = audio.url;
        this.audio.loop = true;
        this.setState({
          name: audio.name,
          url: audio.url
        });
      }
    });
  }
  /** @method componentWillUnmount
    * Disconnects from firebase and pauses any playing audio.
    */
  componentWillUnmount() {
    this.dataRef.off();
    this.audio.pause();
  }
  /** @method handleFileChange
    * Processes any uploaded files.
    */
  handleFileChange(event) {
    var ref = firebase.storage().ref().child(this.props.dataURL);
    var file = event.target.files[0];
    this.setState({loading: true});
    ref.put(file).then(()=>{
      ref.getDownloadURL().then((url) => {
        this.audio.src = url;
        this.audio.loop = true;
        this.setState({
          loading: false,
          name: file.name,
          url: url
        });
        this.dataRef.set({
          name: file.name,
          url: url
        });
      });
    });
  }
  /** @method playAudio
    * Plays the audio
    */
  playAudio() {
    this.audio.play();
    this.setState({isPlaying: true});
  }
  /** @method pauseAudio
    * Pauses the audio.
    */
  pauseAudio() {
    this.audio.pause();
    this.setState({isPlaying: false});
  }
  /** @method removeAudio
    * Removes the audio from firebase.
    */
  removeAudio() {
    var message = "Are you sure?  This will permanently delete the background noise.";
    if(window.confirm(message)) {
      var ref = firebase.storage().ref().child(this.props.dataURL);
      ref.delete()
      .then(() => {
        this.dataRef.remove();
        this.setState({
          name: '',
          url: ''
        });
      })
      .catch(err => {
        console.error(err);
      });
    }
  }
  /** @method render
    * Renders the control.
    */
  render() {
    var sound = (
      <div className="noise-details">
        <i>No background noise</i>
      </div>
    )
    if(this.state.url) {
      var playPauseBtn = this.state.isPlaying ?
        <FontAwesome name="pause" onClick={this.pauseAudio} style={{color: 'orange'}}/> :
        <FontAwesome name="play" onClick={this.playAudio} style={{color: 'green'}}/>
      sound = (
        <div className="noise-details">
          {this.state.name}
          <span>
            {playPauseBtn}
            <FontAwesome name="times" onClick={this.removeAudio} style={{color: 'red'}}/>
          </span>
        </div>
      )
    }
    return (
      <div className="background-noise">
        <label>Background Noise</label>
        {sound}
        <input name="audio" type="file"
          value="" onChange={this.handleFileChange}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/stage-editor/background-noise.js